import { render } from "./SearchSlider.vue?vue&type=template&id=b9a380b2"
import script from "./SearchSlider.vue?vue&type=script&lang=js"
export * from "./SearchSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__